import script from "./addPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./addPhoto.vue?vue&type=script&setup=true&lang=js"

import "./addPhoto.vue?vue&type=style&index=0&id=6b981bb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b981bb4"]])

export default __exports__